/**
 * @generated SignedSource<<56e59c01b7ac91cae0733bf169c033e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MyPageSns$data = {
  readonly linkingInstagram: boolean | null;
  readonly linkingTwitter: boolean | null;
  readonly profile: {
    readonly tiktokUrl: string | null;
    readonly ytChannel: string | null;
  };
  readonly " $fragmentType": "MyPageSns";
};
export type MyPageSns$key = {
  readonly " $data"?: MyPageSns$data;
  readonly " $fragmentSpreads": FragmentRefs<"MyPageSns">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyPageSns",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingInstagram",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkingTwitter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ytChannel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "8015634ec06ea54085f6ce9fa7f36f47";

export default node;
